import React, { useEffect } from 'react'
import NavbarContainer from '../components/Navbar/Navbar'
import ShippingContainer from '../components/ShippingContainer/ShippingContainer'
import Footer from '../components/Footer/Footer'
import {  Container, Row } from 'react-bootstrap'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

function Shipping() {
  const { pathname } = useLocation();
  const layout = useSelector((state) => state.layoutRducer.layoutArray);

  useEffect(() => {
    window.scrollTo(0, 0);

  }, [pathname]);

  return (
 

    <>
    <NavbarContainer/>
    <Container>
      <Row>
        <ShippingContainer layout={layout}/>


      </Row>
    </Container>
    <Footer/>
    </>  )
}

export default Shipping